import type { VoteOnPoll200MostVotedOption } from './voteOnPoll200MostVotedOption';
import type { VoteOnPoll200OptionsItem } from './voteOnPoll200OptionsItem';

/**
 * 투표 결과 정보 (결과 포함)
 */
export type VoteOnPoll200 = {
  durationMinutes?: number;
  expiresAt?: string;
  isExpired: boolean;
  /**
   * 투표 결과의 선택지 정보
   * @nullable
   */
  mostVotedOption?: VoteOnPoll200MostVotedOption;
  /** 투표 선택지 목록 및 결과 (% 포함) */
  options: VoteOnPoll200OptionsItem[];
  pollId: string;
  question: string;
  totalVotes: number;
  /** @nullable */
  userVotedOptionId?: string | null;
};
